/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom"
import Slider from "react-slick";
import $ from 'jquery';
import TagManager from 'react-gtm-module';

function Caption05() {
	const inputRef1 = useRef();
	const inputRef2 = useRef();
	const inputRef3 = useRef();
	const inputRef4 = useRef();
	const inputRef5 = useRef();
	const inputRef6 = useRef();
	const inputRef7 = useRef();
	const inputRef8 = useRef();
	var settings = {
		dots: true,
		infinite: true,
		slidesToShow: 8,
		slidesToScroll: 1,
		responsive:[
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			}
		]
	};
	var settings_talk = {
		dots: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		vertical: true,
		customPaging: i => (
			<div style={{ fontSize: "17px" }}>{i + 1}</div>
		),
	};
	let location = useLocation();
	const tagManagerArgs = { gtmId: 'GTM-NDBLPCX' }
	TagManager.initialize(tagManagerArgs);

	useEffect(() => {
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])
	
	$(".btn_popup").on('click', function () {
		$(".popup").hide();
		var href = "#" + $(this).attr('id');
		$(href).show();
	})
	$(".btn_close").on('click', function () {
		$(".popup").hide();
	});

	return (
		<>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">服務說明 - 情境模式</h2>
							<div className="caption_box caption_05">
								<div className="title">
									<h2>聲控智慧家電<span className="d-lg-inline-block d-none">，</span><br className="d-lg-none d-block" />八種情境任你切換</h2>
									<p>一個口令，同時執行多項功能，好輕鬆！<br className="d-lg-none d-block" />自由搭配不同功能組合，創造個人情境</p>
								</div>
								<div className="nav_main">
									<ul className="nav-slick" >
										<Slider {...settings}>
											<li>
												<a className="nav_main_link" onClick={() => inputRef1.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-01"></div>
													睡眠模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef2.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-02"></div>
													起床模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef3.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-03"></div>
													用餐模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef4.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-04"></div>
													劇院模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef5.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-05"></div>
													回家模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef6.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-06"></div>
													外出模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef7.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-07"></div>
													閱讀模式
												</a>
											</li>
											<li>
												<a className="nav_main_link" onClick={() => inputRef8.current.scrollIntoView({ behavior: 'smooth' })}>
													<div className="icon-area icon-area-08"></div>
													居家模式
												</a>
											</li>
										</Slider>
									</ul>
								</div>

								<div className="section-item section01" id="section01">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef1}>
												<img src={require("../../image/caption_05/ico_mode_1@3x.png").default} alt=""></img>
												睡眠模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section01_talk01.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section01_talk02.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section01_talk03.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section01_talk04.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion01_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion01_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion01_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion01_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section02" id="section02">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef2}>
												<img src={require("../../image/caption_05/ico_mode_2@3x.png").default} alt=""></img>
												起床模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section02_talk01.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section02_talk02.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion02_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion02_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion02_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion02_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section03" id="section03">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef3}>
												<img src={require("../../image/caption_05/ico_mode_3@3x.png").default} alt=""></img>
												用餐模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section03_talk01.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section03_talk02.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion03_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion03_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion03_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion03_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section04" id="section04">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef4}>
												<img src={require("../../image/caption_05/ico_mode_4@3x.png").default} alt=""></img>
												劇院模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section04_talk01.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section04_talk02.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion04_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion04_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion04_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion04_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section05" id="section05">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef5}>
												<img src={require("../../image/caption_05/ico_mode_5@3x.png").default} alt=""></img>
												回家模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section05_talk01.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section05_talk02.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section05_talk03.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion05_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion05_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion05_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion05_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section06" id="section06">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef6}>
												<img src={require("../../image/caption_05/ico_mode_6@3x.png").default} alt=""></img>
												外出模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section06_talk01.png").default} alt=""></img>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section06_talk02.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion06_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion06_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion06_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion06_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section07" id="section07">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef7}>
												<img src={require("../../image/caption_05/ico_mode_7@3x.png").default} alt=""></img>
												閱讀模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section07_talk01.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion07_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion07_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion07_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion07_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>

								<div className="section-item section08" id="section08">
									<div className="section-title">
										<div className="section-title-item">
											<div className="section-icon" ref={inputRef8}>
												<img src={require("../../image/caption_05/ico_mode_8@3x.png").default} alt=""></img>
												居家模式
											</div>
											<div className="section-talk">
												<p>喚醒語</p>
												<div className="talk-slick">
													<Slider {...settings_talk}>
														<img src={require("../../image/caption_05/dialog/dialog_pc/section08_talk01.png").default} alt=""></img>
													</Slider>
												</div>
											</div>
										</div>
										<div className="more">
											<Link to={"/container/teaching/Teaching0204"}>	情境模式設定教學 {'>'}</Link>
										</div>
									</div>
									<div className="section-content">
										<div className="section-content-slick white-arrow d-lg-block d-none">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion08_kv01.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion08_kv02.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="section-content-slick d-lg-none d-block">
											<Slider {...{ autoplay: true, speed: 1000, autoplaySpeed: 5000 }}>
												<img src={require("../../image/caption_05/setion08_kv01_m.png").default} alt=""></img>
												<img src={require("../../image/caption_05/setion08_kv02_m.png").default} alt=""></img>
											</Slider>
										</div>
										<div className="ibaby">
											<img src={require("../../image/caption_05/ibaby.png").default} alt=""></img>
										</div>
									</div>
									<div className="text-right">
										<span className="tips">
											＊ 生活助理類的功能可同時設定多項、影視娛樂及音樂故事類的功能可擇一開啟、<br className="d-lg-block d-none" />智慧家電則依據搭配之產品使用（查看<Link to="/container/caption/Caption0201" target="_blank">支援家電清單</Link>）。
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption05;